import { render } from "./tw-slider.vue?vue&type=template&id=4ede5e9e"
import script from "./tw-slider.vue?vue&type=script&lang=js"
export * from "./tw-slider.vue?vue&type=script&lang=js"
script.render = render

export default script